import 'url-search-params-polyfill';
import { add } from 'stickyfilljs';

$(document).ready(() => {
  const $elements = $('.sticky');
  if ($elements.length > 0) {
    add($elements);
  }
});
